module.exports = __webpack_public_path__ + "img/cloud-rain-2-sun.30e765e1.svg";